import Dupecheck from "../../../jsx/components/Dashboard/DupeCheck/dupecheck";

const DupeCheckWrapper = () => {
  return <Dupecheck />;
};

export default constore(DupeCheckWrapper);
